import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as PositiveIcon } from "Assets/svg/sentiment/positive.svg";
import { ReactComponent as NegativeIcon } from "Assets/svg/sentiment/negative.svg";
import { ReactComponent as NeutralIcon } from "Assets/svg/sentiment/neutral.svg";
import { ReactComponent as NoSentimentIcon } from "Assets/svg/sentiment/no-sentiment.svg";

/**
 * SentimentIcon Component
 * Displays sentiment icons based on the sentiment value
 * Used in the Inbox table when "Replied" filter is active
 */
const SentimentIcon = ({ sentiment }) => {
  const getSentimentConfig = () => {
    switch (sentiment) {
      case "POSITIVE":
        return {
          Icon: PositiveIcon,
          ariaLabel: "Positive sentiment"
        };
      case "NEGATIVE":
        return {
          Icon: NegativeIcon,
          ariaLabel: "Negative sentiment"
        };
      case "NEUTRAL":
        return {
          Icon: NeutralIcon,
          ariaLabel: "Neutral sentiment"
        };
      default:
        return {
          Icon: NoSentimentIcon,
          ariaLabel: "No sentiment available"
        };
    }
  };

  const config = getSentimentConfig();
  const IconComponent = config.Icon;

  return (
    <div
      className="sentimentIconWrapper"
      aria-label={config.ariaLabel}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        cursor: "default"
      }}
    >
      <IconComponent
        style={{
          width: "16px",
          height: "16px"
        }}
      />
    </div>
  );
};

SentimentIcon.propTypes = {
  sentiment: PropTypes.oneOf(["POSITIVE", "NEGATIVE", "NEUTRAL", null])
};

SentimentIcon.defaultProps = {
  sentiment: null
};

export default SentimentIcon;
